/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { createContext, useEffect, useReducer } from 'react';
import PropTypes from 'prop-types';
import { useMutation, useLazyQuery, useQuery } from '@apollo/client';
import { toast } from 'react-toastify';

// utils
import { useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import axios from '../utils/axios';
import { isValidToken, setSession } from '../utils/jwt';
import { HOST_API } from '../config';

import { CREATE_SELLER } from '../graphql/Seller';
import { ME } from '../graphql/User';
import { client } from '../graphql/Server';
import { onAuthenticated } from '../redux/slices/auth';

// ----------------------------------------------------------------------

const initialState = {
  isAuthenticated: false,
  isInitialized: false,
  user: null,
};

const handlers = {
  INITIALIZE: (state, action) => {
    const { isAuthenticated, user } = action.payload;
    return {
      ...state,
      isAuthenticated,
      isInitialized: true,
      user,
    };
  },
  LOGIN: (state, action) => {
    const { user } = action.payload;

    return {
      ...state,
      isAuthenticated: true,
      user,
    };
  },
  LOGOUT: (state) => ({
    ...state,
    isAuthenticated: false,
    user: null,
  }),
  REGISTER: (state, action) => {
    const { user } = action.payload;

    return {
      ...state,
      isAuthenticated: true,
      user,
    };
  },
};

const reducer = (state, action) => (handlers[action.type] ? handlers[action.type](state, action) : state);

const AuthContext = createContext({
  ...initialState,
  method: 'jwt',
  Login: () => Promise.resolve(),
  logout: () => Promise.resolve(),
  register: () => Promise.resolve(),
});

// ----------------------------------------------------------------------

AuthProvider.propTypes = {
  children: PropTypes.node,
};

function AuthProvider({ children }) {
  const storeDispatch  = useDispatch()
  const [RegisterSeller] = useMutation(CREATE_SELLER, {
    onCompleted() {
      toast.success('Store successfully created.');
    },
    onError({ graphQLErrors, networkError }) {
      if (graphQLErrors && graphQLErrors.length > 0) {
        graphQLErrors.map(({ message }) => toast.error(message));
        console.log('afterSubmit', { message: graphQLErrors[0].message });
      }
      if (networkError && networkError.result.errors.length > 0) {
        toast.error(`Something Went Wrong`);
      }
    },
  });
  const [state, dispatch] = useReducer(reducer, initialState);

  const { data } = useQuery(ME, {
    onCompleted(response) {
      console.log('response', response.me);
      dispatch({ type: 'INITIALIZE', payload: { isAuthenticated: true, user: response?.me } });
    },
  });

  

  useEffect(() => {
    const initialize = async () => {
      try {
        const params = new URLSearchParams(window.location.search);
        let accessToken = params.get('accessToken');
        console.log(accessToken);
        if (accessToken) {
          accessToken = accessToken?.replace(/"/g, '');
        }

        if (!accessToken) {
          accessToken = window.localStorage.getItem('accessToken') || window.sessionStorage.getItem('accessToken');
        }

        console.log(accessToken);

        console.log(accessToken && isValidToken(accessToken));

        if (accessToken && isValidToken(accessToken)) {
          setSession(accessToken);

          const response = await client.query({
            query: ME,
          });
          console.log(response.data?.me, 'refresh');
          dispatch({
            type: 'INITIALIZE',
            payload: {
              isAuthenticated: true,
              user: response.data?.me,
            },
          });
          storeDispatch(onAuthenticated(response?.data?.me || {}))

        } else {
          dispatch({
            type: 'INITIALIZE',
            payload: {
              isAuthenticated: false,
              user: null,
            },
          });
        }
      } catch (err) {
        console.error(err);
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null,
          },
        });
      }
    };

    initialize();
  }, []);

  const Login = async (data) => {
    const { token, user } = data;
    console.log({ afterUserLOgin: user });
    setSession(token);
    dispatch({
      type: 'LOGIN',
      payload: {
        user,
      },
    });
  };
  const register = async (args) => {
    console.log('Registration start');
    await RegisterSeller({
      variables: { ...args },
    })
      .then((e) => {
        console.log(e);
      })
      .catch((e) => {
        console.error(e);
      });

    // const response = await axios.post('/api/account/register', {
    //   email,
    //   password,
    //   firstName,
    //   lastName,
    // });
    // const { accessToken, user } = response.data;

    // window.localStorage.setItem('accessToken', accessToken);
    // dispatch({
    //   type: 'REGISTER',
    //   payload: {
    //     user,
    //   },
    // });
  };

  const logout = async () => {
    setSession(null);
    dispatch({ type: 'LOGOUT' });
  };

  return (
    <AuthContext.Provider
      value={{
        ...state,
        method: 'jwt',
        Login,
        logout,
        register,
        // updateUserInfo: getUser,
        subscriptions: data?.me?.store?.subscriptions,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export { AuthContext, AuthProvider };
